import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CustomAsyncSelect from '@/components/CustomAsyncSelect';
import CustomDateInput from '@/components/CustomDateInput';
import { locationOpt } from '@/actions/Helper';
import styles from './styles';
import {
  addExportInventory,
  getTerminalsList,
  SaveApiResMessage,
} from '@/actions';
import CustomSelectEx from '@/ctComponents/CustomSelectEx';
import NumberInput from '@/components/NumberInput';
import SubmitButton from '@/ctComponents/submitButton';
import CloseButton from '@/ctComponents/closeButton';
import { Input } from '@/components/Input';

export default ({ notify, setData, getExportInventoryList, setOpenAdd }) => {
  const cls = styles();
  const [btnLoading, setBtnLoading] = React.useState(false);
  const [resetLoading, setResetLoading] = React.useState(false);
  const selectOp = useSelector((state) => state.reducer);
  const [terminalsList, setTerminalsList] = useState([]);
  const [showBookingNames, setShowBookingNames] = useState(true);
  const [showbookings, setShowBookings] = React.useState(false);
  const [terminalsSelectOptions, setTerminalsSelectOptions] = useState([]);
  const [selectedTerminal, setSelectedTerminal] = useState('All');

  const [form, setFormData] = React.useState({
    size: null,
    ssl: null,
    date: null,
    count: 1,
    loc: null,
    bookingNumber: '',
    erd: null,
    cutoff: null,
    bol: null,
    mto: null,
    appointment_date: null,
    chassis: {
      own: true,
      pool: true,
    },
  });

  // Validation function to check if all required fields are filled
  const isFormValid = () => {
    // Required fields (excluding additional inputs)
    const requiredFields = {
      size: form.size,
      ssl: form.ssl,
      date: form.date,
      count: form.count,
      loc: form.loc,
      bookingNumber: form.bookingNumber,
    };

    // Check if any required field is empty
    for (let field in requiredFields) {
      if (!requiredFields[field]) {
        return false;
      }
    }

    // Check if bookingNumber is not just whitespace
    if (!form.bookingNumber.trim()) {
      return false;
    }

    return true;
  };

  const getTerminalsListFanc = () => {
    getTerminalsList()
      .then((res) => {
        const terminalsRes = Object.values(res.data.terminals);
        if (terminalsRes) {
          setTerminalsList(terminalsRes);
        }
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  useEffect(() => {
    getTerminalsListFanc();
  }, []);

  useEffect(() => {
    if (terminalsList.length > 0) {
      const options = terminalsList.map((terminal, index) => ({
        label: terminal.name,
        slug: terminal.slug,
        value: index + 1,
      }));
      setTerminalsSelectOptions(options);
    }
  }, [terminalsList]);

  const setForm = (it, val) => setFormData({ ...form, [it]: val });

  const Add = () => {
    setBtnLoading(true);
    addExportInventory({
      ...form,
    })
      .then((res) => {
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Added Successfully.',
          mode: 'success',
        });
        getExportInventoryList();
        Reset();
        setBtnLoading(false);
        if (setOpenAdd) {
          setOpenAdd(false);
        }
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setData([]);
        setBtnLoading(false);
      });
  };

  const Reset = () => {
    setResetLoading(true);
    setFormData({
      size: null,
      ssl: null,
      date: new Date(),
      count: 1,
      loc: null,
      bookingNumber: '',
      erd: null,
      cutoff: null,
      mto: null,
      appointment_date: null,
      chassis: {
        own: true,
        pool: true,
      },
    });
    setShowBookings(false);
    setTimeout(() => {
      setResetLoading(false);
    }, 500);
  };

  return (
    <div className="w-full overflow-visible">
      <div style={{ maxWidth: '650px', padding: '12px 0px' }}>
        Fill out the form below and click Add. You can edit or delete entries
        later from your Export list.
      </div>

      <div className="space-y-4 md:space-y-0 md:grid grid-cols-1 md:grid-cols-2 gap-4 max-w-screen-sm">
        <CustomSelectEx
          height={48}
          maxHeight={48}
          title={'Size'}
          placeholder={
            form.size?.label !== null
              ? form.size?.label
              : form.size
              ? form.size.label
              : 'Size'
          }
          value={form.size}
          onChange={(item) => setForm('size', item)}
          options={selectOp.size}
        />

        <CustomSelectEx
          height={48}
          maxHeight={48}
          title={'SSL'}
          placeholder={
            form.ssl?.label !== null
              ? form.ssl?.label
              : form.ssl
              ? form.ssl.label
              : 'SSL'
          }
          value={form.ssl}
          onChange={(item) => setForm('ssl', item)}
          options={selectOp.ssl}
        />

        <NumberInput
          label="Number"
          value={form.count}
          onChange={(value) => setForm('count', value)}
          min={1}
          onIncrement={() => {
            setForm('count', form.count + 1);
          }}
          onDecrement={() => setForm('count', Math.max(1, form.count - 1))}
        />

        <Input
          label="Booking#"
          type="text"
          maxLength={12}
          placeholder="Booking#"
          value={form.bookingNumber}
          onChange={(e) => setForm('bookingNumber', e.target.value)}
        />

        <CustomAsyncSelect
          height={48}
          maxHeight={48}
          title="Location"
          placeholder="Search your location"
          value={form.loc}
          loadOptions={locationOpt}
          onChange={(item) => setForm('loc', item)}
          cacheOptions={true}
          defaultOptions={true}
        />

        <CustomDateInput
          height={48}
          title="Date"
          placeholder="Available date"
          value={form.date}
          onChange={(item) => setForm('date', item)}
          format="MM/dd/yyyy"
        />
      </div>

      {showBookingNames && (
        <div className="py-4">
          <div
            className="flex items-center mb-4 cursor-pointer"
            onClick={() => {
              const newValue = !showbookings;
              setShowBookings(newValue);
              localStorage.setItem('smart_user_show_bookings', newValue);
            }}>
            <input
              type="checkbox"
              className="mr-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
              checked={showbookings}
              onChange={(e) => {
                setShowBookings(e.target.checked);
                localStorage.setItem(
                  'smart_user_show_bookings',
                  e.target.checked
                );
              }}
            />
            <span className="text-sm text-gray-700 font-medium">
              Show Additional Inputs
            </span>
          </div>

          {showbookings && (
            <div className="space-y-4 md:space-y-0 md:grid grid-cols-1 md:grid-cols-2 gap-4 max-w-screen-sm">
              <CustomDateInput
                height={48}
                title="ERD"
                placeholder="ERD"
                value={form.erd}
                onChange={(item) => setForm('erd', item)}
                format="MM/dd/yyyy"
              />

              <CustomDateInput
                height={48}
                title="CutOff"
                placeholder="CutOff"
                value={form.cutoff}
                onChange={(item) => setForm('cutoff', item)}
                format="MM/dd/yyyy"
              />

              <CustomSelectEx
                height={48}
                maxHeight={48}
                title={'MTO'}
                placeholder={
                  form.mto?.label !== null
                    ? form.mto?.label
                    : form.mto
                    ? form.mto.label
                    : 'Select your MTO'
                }
                value={form.mto}
                onChange={(item) => {
                  setForm('mto', item);
                  setSelectedTerminal(item);
                }}
                options={terminalsSelectOptions}
              />

              <CustomDateInput
                height={48}
                title="Terminal Appointment"
                placeholder="Terminal Appointment"
                value={form.appointment_date}
                onChange={(item) => setForm('appointment_date', item)}
                format="MM/dd/yyyy"
              />
            </div>
          )}
        </div>
      )}

      <div className={cls.buttonsSection}>
        <CloseButton
          borderColor={'#FB3748'}
          color={'#FB3748'}
          text={'Reset'}
          onClick={() => Reset()}
          loading={resetLoading}
        />
        <div className="flex flex-row gap-3">
          <CloseButton
            onClick={() => setOpenAdd && setOpenAdd(false)}
            text={'Cancel'}
          />
          <SubmitButton
            text={'Add'}
            onClick={() => Add()}
            loading={btnLoading}
            disable={!isFormValid()}
          />
        </div>
      </div>
    </div>
  );
};
